<template>
  <div class="OP950DocumentsWarehouseSiteWidget">
    <v-layout>
      <v-flex xs6>{{ $t('siteName') }}: {{ info.siteName }}</v-flex>
      <v-flex xs4>{{ $t('authorizationId') }}: {{ info.authorizationId }}</v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs6>{{ $t('city') }}: {{ info.city }}</v-flex>
      <v-flex>{{ $t('address') }}1: {{ info.address1 }}</v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs6>{{ $t('state') }}: {{ abbrevToStates[info.state] || info.state }}</v-flex>
      <v-flex>{{ $t('zipCode') }}: {{ info.zipCode || info.zip }}</v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'OP950DocumentsWarehouseSiteWidget',
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    abbrevToStates () {
      return this.$store.getters.abbrevToStates
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OP950DocumentsWarehouseSiteWidget.vue